<section id="seguranca" class="bg-canvas/60 py-24 lg:py-32">
  <div class="site-container">
    <h2 class="mb-16 text-center text-3xl font-bold lg:mb-20 lg:text-4xl">{{ content.title }}</h2>
    <ul class="grid grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-5">
      @for (item of content.items; track item.title; let last = $last) {
        <li
          class="rounded-lg border border-line/60 bg-surface p-8 text-center transition-all hover:shadow-lg"
          [class]="last ? 'col-span-2 md:col-span-1' : ''"
        >
          <app-icon [name]="item.icon" class="mb-4 text-4xl text-gold" />
          <h3 class="mb-2 font-sans text-sm font-bold uppercase">{{ item.title }}</h3>
          <p class="text-[11px] text-muted">{{ item.description }}</p>
        </li>
      }
    </ul>
  </div>
</section>
